import {
    Analytics,
    safeWrap,
    getSelectedFilters,
    getCheckedFilters,
    getLocationFilter,
    getSelectedSortOption,
    ADD_TO_CART_SELECTOR,
} from '../../analytics/analytics';

const PAGE = 'searchSurgePage';
const { apcLogService } = window;

const preload = safeWrap('preload');
const setVariables = safeWrap('setVariables');
const setPageReady = safeWrap('setPageReady');
const getDefaultPageReadyPromise = safeWrap('getDefaultPageReadyPromise');

class SurgeAnalytics extends Analytics {
    constructor() {
        super();
        this.PAGE = PAGE;
    }

    handleEngagementClick = e => {
        super.handleEngagementClick(e);
        const { target } = e;
        let block = null;
        if (this.matchThisOrChildren(target, ADD_TO_CART_SELECTOR)) {
            block = this.getClosest(target, 'li.result-list__item_product');
            apcLogService(`${PAGE}.addToCart.click`, {
                target,
                productId: block.dataset.productId || '',
                url: window.location.href,
            });
        }
    };
}

try {
    preload(PAGE);
    setPageReady(
        getDefaultPageReadyPromise().then(() => {
            const modelFamily = getSelectedFilters('Product-Category');
            const inputVoltage = getCheckedFilters('Input-Voltage');
            const inputConnection = getCheckedFilters('Input-Connection-Type');
            const productOrientation = getCheckedFilters('Product-Orientation');
            setVariables({
                env_template: 'selector',
                page_name: 'surge-selector_step3-recommendations',
                page_cat1: 'surge-selector',
                page_level: '104',
                sales_insights: '1',
                selector_sort_option: getSelectedSortOption(),
                selector_country_filter: getLocationFilter(),
                selector_model_family: modelFamily,
                selector_input_voltage: inputVoltage,
                selector_input_connection: inputConnection,
                selector_product_orientation: productOrientation,
            });
            new SurgeAnalytics().init();
        }),
    );
} catch (err) {
    console.error(err);
}
